"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _actionUtils = require("../../utils/actionUtils");
var _types = require("./types");
function updateMeetingStatus(status) {
  return (0, _actionUtils.actionCreator)(_types.UPDATE_MEETING_STATUS, status);
}
var _default = exports["default"] = updateMeetingStatus;